import { PaymentMethodMessages } from "@/messages/paymentMethods/payment-method.messages";
import { SelectData } from "@/types/form.types";
import { PaymentMethod } from "@/types/payment.types";

export const PAYMENTS_METHOD = (messages: PaymentMethodMessages): SelectData<PaymentMethod>[] => {
  return [
    { value: PaymentMethod.Pix, label: messages.pixOption },
    { value: PaymentMethod.Card, label: messages.cardOption },
    { value: PaymentMethod.Boleto, label: messages.boletoOption },
  ];
};

export const CARD_NUMBER_MASK = "9999 9999 9999 9999";
export const CARD_EXPIRY_MASK = "99/9999";
export const CARD_CVV_MASK = "999";
